import { SettingsOrganization } from '@/ui'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/company/$companyId/settings/organization')({
	component: SettingsOrganization,
})
